import { esbuildPlugin } from './index.ts';

export default esbuildPlugin;
